import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { LookupDataSource } from "../enums/lookup-datasources";
import { IClub } from "../models/club/club.model";
import { ILanguage } from "../models/generic/language/language.model";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { IPaymentMethodModel } from "../models/payment/payment-method.model";
import { ApplicationContextService } from "./application-context.service";
import { EnvironmentService } from "./environment.service";

@Injectable({
    providedIn: 'root'
})
export class LookUpDataService {
    constructor(private httpClient: HttpClient,
        public envService: EnvironmentService,
        private applicationContext: ApplicationContextService) {
    }
    public get(dataSource: LookupDataSource): Observable<ILookUpType[]> {
        const path = this.getSource(dataSource);
        return this.httpClient.get<ILookUpType[]>(`${this.envService.settings.apiUrl}/${path}`);
    }

    public getLanguage(path: string): Observable<ILanguage[]> {
        return this.httpClient.get<ILanguage[]>(`${this.envService.settings.apiUrl}/${path}`);
    }

    private getSource(dataSource: LookupDataSource): string {
        switch (dataSource) {
            case LookupDataSource.accountStatus: 
                return 'accountStatuses';
            case LookupDataSource.discountLevel: 
                return 'discountLevels';
            case LookupDataSource.countryGoup: 
                return 'countryGrps';
            case LookupDataSource.managedBy: 
                return 'accountManagers';
            case LookupDataSource.shippingMethods: 
                return `options/shippingmethods${this.applicationContext.isApplicationEmbedded() ? '?branchCode=' + this.applicationContext.getBranchCodeFromUrl() : ''}`;
        }

        return '';
    }

    public getClubs(path: string): Observable<IClub[]> {

        //clubs are not needed in a public context
        if (this.applicationContext.isPublic()) {
            return of([])
        }

        return this.httpClient.get<IClub[]>(`${this.envService.settings.apiUrl}/${path}`);
    }

    public getPaymentMethods(onlyReturnMethodsAllowedAsCustomerDefault: boolean): Observable<IPaymentMethodModel[]> {

        if (this.applicationContext.isPublic()) {
            return this.httpClient.get<IPaymentMethodModel[]>(`${this.envService.settings.publicApiUrl}/Options/paymentmethods?onlyPaymentMethodsAllowedAsCustomerDefault=${onlyReturnMethodsAllowedAsCustomerDefault}&branchCode=${this.applicationContext.getBranchCodeFromUrl()}`);
        }

        return this.httpClient.get<IPaymentMethodModel[]>(`${this.envService.settings.apiUrl}/Options/paymentmethods?onlyPaymentMethodsAllowedAsCustomerDefault=${onlyReturnMethodsAllowedAsCustomerDefault}${this.applicationContext.isApplicationEmbedded() ? '&branchCode=' + this.applicationContext.getBranchCodeFromUrl() : ''}`);
    }
}